import { useGetCompany } from 'hooks/api/companies';
import { FC } from 'react';

interface CompanyBreadCrumbsBreadcrumbsProps {
  match?: any;
}

const CompanyBreadcrumbs: FC<CompanyBreadCrumbsBreadcrumbsProps> = ({ match }) => {
  const { companyId } = match?.params ?? '';

  const {data: companyData} = useGetCompany(companyId);

  return <>{companyData?.data.name}</>;
};

export default CompanyBreadcrumbs;
